import React from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import PropTypes from "prop-types";

const CustomDoughnut = ({
  sectorData,
  height,
  width,
  labelData,
  sectorColor,
  showLegend,
  borderWidth,
  maintainAspectRatio,
  showLegendTitle,
  legendAlignment,
  legendBoxHeight,
  legendBoxWidth,
  legendPosition,
  legendTitle,
  enableTooltip,
}) => {
  const data = {
    responsive: true,
    labels: labelData,
    datasets: [
      {
        data: sectorData,
        backgroundColor: sectorColor,
        borderWidth,
      },
    ],
  };
  const options = {
    maintainAspectRatio,
    plugins: {
      tooltip: {
        enabled: enableTooltip,
      },
      legend: {
        display: showLegend,
        position: legendPosition,
        align: legendAlignment,
        title: {
          display: showLegendTitle,
          text: legendTitle,
        },
        labels: {
          boxWidth: legendBoxWidth,
          boxHeight: legendBoxHeight,
        },
      },
    },
  };
  return (
    <Doughnut data={data} height={height} options={options} width={width} />
  );
};
CustomDoughnut.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  labelData: PropTypes.shape([]).isRequired,
  sectorColor: PropTypes.shape([]),
  sectorData: PropTypes.shape([]),
  showLegend: PropTypes.bool.isRequired,
  borderWidth: PropTypes.number.isRequired,
  maintainAspectRatio: PropTypes.bool.isRequired,
  legendBoxWidth: PropTypes.number.isRequired,
  legendBoxHeight: PropTypes.number.isRequired,
  legendPosition: PropTypes.string.isRequired,
  legendAlignment: PropTypes.string.isRequired,
  showLegendTitle: PropTypes.bool.isRequired,
  enableTooltip: PropTypes.bool.isRequired,
  legendTitle: PropTypes.string.isRequired,
};
CustomDoughnut.defaultProps = {
  width: 500,
  height: 100,
  sectorColor: ["#50CD89", "#DF2D2D"],
  sectorData: ["15", "5"],
};
export default CustomDoughnut;
